import { useEffect, useState } from 'react';
const isConsentRequired = () => {
    if (window?.UC_UI) {
        return window.UC_UI.isConsentRequired();
    }
    return true;
};
export const useConsent = () => {
    const [consent, setConsent] = useState(false);
    useEffect(() => {
        // Thor sync with the Usercentric cookie banner
        const userConsentInterval = setInterval(() => {
            if (!isConsentRequired()) {
                clearInterval(userConsentInterval);
                setConsent(true);
            }
        }, 500);
        return () => {
            clearInterval(userConsentInterval);
        };
    }, []);
    return consent;
};
